import { ConfirmationModal, Text } from '@shared/components';

export interface QSetMarkExamUsageAsInactiveModalProps {
  selectedQSets: string[];
  open: boolean;
  onClose: () => void;
  handleSubmit: (qsetId: string[]) => Promise<void>;
  loading: boolean;
}

export default function QSetMarkExamUsageAsInactiveModal(
  props: Readonly<QSetMarkExamUsageAsInactiveModalProps>,
) {
  const { open, onClose, selectedQSets, handleSubmit, loading } = props;

  return (
    <ConfirmationModal
      open={open}
      title='Mark as Inactive?'
      loading={loading}
      content={
        <Text>
          คุณกำลังจะเปลี่ยนสถานะของชุดข้อสอบจำนวน {selectedQSets.length} ชุด ให้เป็น{' '}
          <Text variant='body1Semibold'>{'Inactive\n'}</Text>
          {'เพื่อหยุดการนำไปใช้ในการจัดสอบ\nกรุณาตรวจสอบความถูกต้องก่อนดำเนินการต่อ'}
        </Text>
      }
      acceptText='Mark as Inactive'
      onAccept={() => handleSubmit(selectedQSets)}
      onDiscard={onClose}
      onClose={onClose}
    />
  );
}
